import React, { Component } from 'react';
import '../../css/moj.css';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Firebase from '../Firebase';
import { Table } from 'react-bootstrap';
import Schools from '../../Data/Schools.json';
import Qestions1 from '../../Data/Qestions1.json';
import {Row} from 'react-bootstrap'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
class Moj_go_th3 extends Component{

    render(){
        return(
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="data_center">
                <p style={{ textAlign: 'center', fontSize: 26 }}>
                    <strong>
                        แบบสอบถาม
                        <br></br>
                        โครงการโรงเรียนยุติธรรมอุปถัมภ์
                    <br></br>
                        สำนักงานกิจการยุติธรรม
                    <br></br>
                        (สำหรับผู้บริหารโรงเรียน)
                    </strong>
                </p>
                <br></br>
                <hr style={{ width: '80%' }}></hr>
                <Data></Data>
                <p>ติดต่อผู้พัฒนา email:adison.ra.56@ubu.ac.th  line-ID:oqiew2537</p>
                </div>
            </div>
        )
    }
}


class Data extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step:0,
            QName:'',
            QLast_name:'',
            QDate:'',
            QTime:'',
            QLocation:'',
            AName:'',
            ALast_name:'',
            AStatus:'',
            ADetail:'',
            Answer1:'',
            Answer2:'',
            Answer3:'',
            Answer4:'',
        }
    }
    componentDidMount() {
 
       

    }

    onChange = (e) => {
        const state = this.state
        state[e.target.name] = e.target.value;
        this.setState(state);

    }

    nextStep2=(e)=>{
        e.preventDefault();
        if( this.state.School_name!==''){
            this.setState({
                step:2
            })
         
        }
    }
    selectDate = date => {
        this.setState({
            QDate: date,
        });
    };
    onSubmit=(e)=>{
        e.preventDefault();
        const {  QName,QLast_name,QDate,QTime,QLocation,AName,ALast_name,AStatus,ADetail,Answer1,Answer2,Answer3,Answer4 } = this.state;
        const Create_date = new Date();
            Firebase.firestore().collection('MOJ1S').add({
                QName,QLast_name,QDate,QTime,QLocation,AName,ALast_name,AStatus,
                ADetail,Answer1,Answer2,Answer3,Answer4,Create_date,rule:'ผู้บริหาร'
            }).then((doc)=>{
                console.log('success');
                confirmAlert({
                    title: 'บันทึกสำเร็จ',
                    message: ' ขอบคุณที่สละเวลาตอบแบบสอบถาม',
                    closeOnClickOutside: true,
                    buttons: [
                        {
                            label: 'ตกลง',
                            onClick: () => this.setState({
                                reset_password: false,
                                login: true,

                            })
                        },

                    ]
                });
                this.setState({
                    step:0,
                    QName:'',
                    QLast_name:'',
                    QDate:'',
                    QTime:'',
                    QLocation:'',
                    AName:'',
                    ALast_name:'',
                    AStatus:'',
                    ADetail:'',
                    Answer1:'',
                    Answer2:'',
                    Answer3:'',
                    Answer4:'',
                })
            }).catch((error)=>{
                console.log(error,'error');
            })
       
        
    }
    render() {
        const { QName,QLast_name,QDate,QTime,QLocation,AName,ALast_name,AStatus,ADetail,Answer1,Answer2,Answer3,Answer4} = this.state;
        if (this.state.step === 0) {
            return (
               <div>
                    <div style={{ margin: '3%' }}>
                        <p style={{ textDecoration: 'underline', fontSize: 20 }}>
                            คำชี้แจง
                        </p>

                        <p style={{ fontSize: 18, lineHeight: 2, }}>
                            <span style={{ marginLeft: '3%' ,marginRight:'3%'}}> </span>
                            โครงการโรงเรียนยุติธรรมอุปถัมภ์ ดำเนินการโดยหน่วยงานในสังกัดกระทรวงยุติธรรม 10 หน่วยงาน ร่วมมือกับสถานศึกษาในพื้นที่
                             ทั้งในสังกัดกระทรวงศึกษาธิการ กระทรวงมหาดไทย และกรุงเทพมหานคร เพื่อการจัดกิจกรรมเสริมสร้างจิตสำนึกรักความยุติธรรม 
                             การรับรู้กฎกติกาที่เหมาะสมกับช่วงอายุของเด็กแต่ละวัย ภายใต้กรอบเนื้อหาการดำเนินโครงการฯ 4 กรอบเนื้อหาได้แก่ 1. การป้องกันตนเองจากภัยสังคม 2.
                              การสร้างจิตสำนึกและวินัยในตนเอง 3. การรู้เท่าทันและห่างไกลจากยาเสพติด 4. การต่อต้านการทุจริตคอร์รัปชัน ตามแนวทาง “โรงเรียนดี มีภูมิคุ้มกัน 
                              รู้เท่าทันภัยสังคม”  โดยมีรูปแบบการจัดกิจกรรมสร้างภูมิคุ้มกันทางสังคมสำหรับเด็กและเยาวชน เน้นการป้องกันและร่วมแก้ไขปัญหาที่เกิดขึ้นในโรงเรียนด้วยตนเองเพื่อให้เกิดความยั่งยืน ผ่านกระบวนการระดมความคิด วิเคราะห์สภาพปัญหา รวมทั้งประเมินผลสำเร็จในการดำเนินกิจกรรมในโรงเรียนทั้งด้านผลผลิต 
                              และผลลัพธ์ของการดำเนินกิจกรรม โดยการจัดทำเครื่องมือการประเมินผลการดำเนินกิจกรรมในโรงเรียน และประเมินผลการดำเนินกิจกรรม
                               เพื่อประเมินผลลัพธ์ที่เกิดกับตัวเด็กและเยาวชนที่เข้าร่วมกิจกรรม 
                               ซึ่งจะใช้เป็นข้อมูลในการพัฒนากิจกรรมที่เหมาะสมกับเด็กและเยาวชนและตอบสนองความต้องการที่สามารถนำไปสู่การแก้ไขปัญหา 
                               อันจะเป็นการพัฒนาศักยภาพให้เด็กและเยาวชนมีภูมิคุ้มกันที่ดียิ่งขึ้นต่อไป
                             ทั้งนี้ มีการติดตามและประเมินผลการดำเนินกิจกรรมภายใต้โครงการโรงเรียนยุติธรรม 
                             โดยการสัมภาษณ์แบบมีโครงสร้าง( Structured Interview ) 
                            <br></br>
                            <span style={{ marginLeft: '3%' }}> </span>
                            ทั้งนี้ เพื่อให้ผลการศึกษาสามารถสะท้อนความเป็นจริงตามความความคิดเห็นของท่านได้เป็นอย่างดีท่านสามารถแสดงความคิดเห็นได้อย่างเป็นอิสระ
                            และขอยืนยันว่าข้อมูลส่วนบุคคลและคำตอบของท่านจะถูกเก็บไว้เป็นความลับและไม่ถูกนำไปเผยแพร่หรือใช้เพื่อการใด ๆ 
                            ทั้งสิ้น ความร่วมมือของท่านจะช่วยสนับสนุนการพัฒนารูปแบบการดำเนินงานของหน่วยงานภาครัฐในการป้องกันอาชญากรรมให้กับประชาชนภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์
                             จะช่วยสนับสนุนการพัฒนารูปแบบกิจกรรมที่เหมาะสมแก่เด็กและเยาวชนภายใต้การดำเนินงานโครงการโรงเรียนยุติธรรมอุปถัมภ์
                             โดยความร่วมมือของหน่วยงานสังกัดกระทรวงยุติธรรม                        </p>

                    </div>
                    <div style={{ justifyContent: 'center', display: 'flex', marginBottom: 100 }}>
                        <button type="submit" onClick={() => { this.setState({ step: 1 }) }} style={{ padding: 10, borderRadius: 10, backgroundColor: '#00ff80', fontSize: 20 }}>เริ่มทำแบบสอบถาม</button>
                    </div>
                </div>
            )
        } else {
            return (
                            <form onSubmit={this.onSubmit}>
                                {/* 1 */}
                                <p style={{textAlign:'center'}}><strong className="titie3">แบบสัมภาษณ์</strong></p>
                                <p><strong>ส่วนนำ</strong></p>
                                <p>ชื่อโครงการ : การติดตามและประเมินผลการดำเนินงานโครงการโรงเรียนยุติธรรมอุปถัมภ์</p>
                                <p><strong>ส่วนผู้สัมภาษณ์</strong></p>
                                <p>ชื่อ – สกุล ผู้สัมภาษณ์</p>
                                <Row style={{marginLeft:'3%'}}>
                                    <input  required name="QName" value={QName} placeholder="ชื่อ" onChange={this.onChange}></input>
                                    <span style={{width:20}}></span>
                                    <input  required name="QLast_name" value={QLast_name} placeholder="นามสกุล" onChange={this.onChange}></input>
                                </Row>
                                <p>วัน/เดือน/ปี ที่สัมภาษณ์</p>
                                <div style={{marginLeft:'3%'}}>
                                    <DatePicker
                                        required
                                        dateFormat="dd/MM/yyyy"
                                        selected={QDate}
                                        onChange={this.selectDate}
                                        placeholderText="วัน/เดือน/ปี(ค.ศ.)"

                                    />
                                </div>
                                
                                <p>เวลา</p>
                                <input  requiredstyle={{marginLeft:'3%'}} name="QTime" value={QTime} placeholder="00.00" onChange={this.onChange}></input>
                                <p>สถานที่สัมภาษณ์</p>
                                <input  requiredstyle={{marginLeft:'3%'}} name="QLocation" value={QLocation}  onChange={this.onChange}></input>
                                <br></br>
                                <p><strong>ส่วนผู้ถูกสัมภาษณ์</strong></p>
                                <p>ผู้ถูกสัมภาษณ์</p>
                                <Row style={{marginLeft:'3%'}}>
                                    <input  required name="AName" value={AName} placeholder="ชื่อ" onChange={this.onChange}></input>
                                    <span style={{width:20}}></span>
                                    <input  required name="ALast_name" value={ALast_name} placeholder="นามสกุล" onChange={this.onChange}></input>
                                </Row>
                                <p>สถานะ</p>
                                <input  requiredstyle={{marginLeft:'3%'}} name="AStatus" value={AStatus}  onChange={this.onChange}></input>
                                <p>ส่วนเกี่ยวข้องกับโครงการ</p>
                                <input  requiredstyle={{marginLeft:'3%'}} name="ADetail" value={ADetail}  onChange={this.onChange}></input>
                                <br></br>
                                <p><strong>ส่วนคำถาม</strong></p>
                                <p>คำถามในการสัมภาษณ์</p>
                                <div style={{marginLeft:'3%'}}>
                                    <p>
                                    1.	จากการที่นักเรียนในโรงเรียนเข้าร่วมกิจกรรมสร้างภูมิคุ้มให้เด็กและเยาวชนในโรงเรียนท่านเห็นความเปลี่ยนแปลงเกิดขึ้นหรือไม่ อย่างไร (โปรดอธิบาย)
                                    </p>
                                    <textarea required rows="4" style={{borderRadius:10,width:'80%',marginLeft:'3%'}} name="Answer1" value={Answer1} onChange={this.onChange}></textarea>
                                    <p>
                                    2.	ท่านคิดว่าโครงการโรงเรียนยุติธรรมอุปถัมภ์เป็นประโยชน์ต่อการสร้างความตระหนักรู้ด้านการป้องกันอาชญากรรมและภัยทางสังคมแก่นักเรียนในโรงเรียนของท่านอย่างไร
                                    </p>
                                    <textarea required rows="4" style={{borderRadius:10,width:'80%',marginLeft:'3%'}} name="Answer2" value={Answer2} onChange={this.onChange}></textarea>
                                    <p>
                                    3.	หลังจากที่โรงเรียนของท่านมีการจัดกิจกรรมภายใต้โครงการโรงเรียนยุติธรรมอุปถัมภ์โรงเรียนท่านมีมาตรการส่งเสริมความปลอดภัยในโรงเรียนอย่างไร
                                    </p>
                                    <textarea required rows="4" style={{borderRadius:10,width:'80%',marginLeft:'3%'}} name="Answer3" value={Answer3} onChange={this.onChange}></textarea>
                                    <p>
                                    4.	ท่านมีข้อเสนอในเชิงนโยบายต่อการขับเคลื่อนงานตามแนวทางโรงเรียนยุติธรรมอุปถัมภ์อย่างไร
                                    </p>
                                    <textarea required rows="4" style={{borderRadius:10,width:'80%',marginLeft:'3%'}} name="Answer4" value={Answer4} onChange={this.onChange}></textarea>
                                </div>
                                <br></br>
                                <br></br>
                                <div style={{ justifyContent: 'center', display: 'flex', marginBottom: 100 }}>
                                <button type="submit"  
                                style={{ padding: 10, borderRadius: 10, backgroundColor: '#00ff80', fontSize: 20 }}>
                                ส่งคำตอบ</button>
                                </div>
                            </form>

                         
            )
        } 
    }
}

export default Moj_go_th3




